<template>
  <transition name="fade" mode="out-in">
    <keep-alive include="application-history">
      <router-view></router-view>
    </keep-alive>
  </transition>
</template>
<script>
  export default {}
</script>